import { useAppSelector } from '../store/hooks'
import {
	useGetIncomingInvoicesQuery,
	useGetPendingInvoicesQuery,
	useGetProcessedInvoicesQuery,
	useGetOptionsQuery,
} from '../store/api'

export const useInvoiceProcessing = () => {
	const { incomingCurrentPage, pendingCurrentPage, processedCurrentPage } =
		useAppSelector((state) => state.invoices)

	const {
		data: dataIncomingInvoices,
		isLoading: isLoadingIncomingInvoices,
		isSuccess: isSuccessIncomingInvoices,
	} = useGetIncomingInvoicesQuery(incomingCurrentPage)

	const {
		data: dataPendingInvoices,
		isLoading: isLoadingPendingInvoices,
		isSuccess: isSuccessPendingInvoices,
	} = useGetPendingInvoicesQuery(pendingCurrentPage)

	const {
		data: dataProcessedInvoices,
		isLoading: isLoadingProcessedInvoices,
		isSuccess: isSuccessProcessedInvoices,
	} = useGetProcessedInvoicesQuery(processedCurrentPage)

	const { isLoading: isLoadingOptions } = useGetOptionsQuery()

	const isLoading =
		isLoadingIncomingInvoices ||
		isLoadingPendingInvoices ||
		isLoadingProcessedInvoices ||
		isLoadingOptions

	const isSuccess =
		isSuccessIncomingInvoices &&
		isSuccessPendingInvoices &&
		isSuccessProcessedInvoices

	const isEmpty =
		!isLoading &&
		isSuccess &&
		(!dataIncomingInvoices?.data.length &&
			!dataPendingInvoices?.data.length &&
			!dataProcessedInvoices?.data.length)

	return {
		isLoading,
		isSuccess,
		isEmpty,
	}
}

